import React from 'react';
import { RESUME_OPTIONS } from '../data/resumes';

const Resume = () => {
  return (
    <div className="app-resume">
      <div className="app-section-header">
        <p className="app-section-label">Resume</p>
        <h2 className="app-section-title">Choose a version</h2>
        <p className="app-section-subtitle">
          Pick the resume that matches the role you care about. One is tuned for machine learning and research, the other for software engineering and product work.
        </p>
      </div>

      <div className="app-generic-list">
        {RESUME_OPTIONS.map((resume) => (
          <div key={resume.id} className="app-generic-card">
            <p className="app-generic-subtitle">{resume.label}</p>
            <p style={{ margin: '0 0 12px', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              {resume.description}
            </p>
            <a href={resume.href} download className="app-resume-btn">
              Download {resume.label}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Resume;